module.exports = __webpack_public_path__ + "img/loader.9627baf2.gif";